export default "__VITE_ASSET__qah1O06s__"